module.exports = __webpack_public_path__ + "static/img/WT1100-PF_A.6a44cbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/WT1100-PF_A.jpg
// module id = V1X7
// module chunks = 0